import { render, staticRenderFns } from "./LabList.vue?vue&type=template&id=283fae2a&scoped=true&lang=pug"
import script from "./LabList.vue?vue&type=script&lang=js"
export * from "./LabList.vue?vue&type=script&lang=js"
import style0 from "./LabList.vue?vue&type=style&index=0&id=283fae2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283fae2a",
  null
  
)

export default component.exports